import { render, staticRenderFns } from "./step5.vue?vue&type=template&id=0213498c&scoped=true"
import script from "./step5.vue?vue&type=script&lang=ts"
export * from "./step5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0213498c",
  null
  
)

export default component.exports